export default __webpack_public_path__ + "553fed972e8e0723f02fa4e9669d4c9e.png";